module.exports = __webpack_public_path__ + "static/tailwind-rbii-jacobs-e6a5dec920cc97067c3dfcd76e7499e6.png";